import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const MistakeNotice = styled.div `
  display: flex;
  align-items: center;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.secondary};
`;
export const UpgradeNotice = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.swatches.blue[50]};
`;
